import AutoComplete from 'antd/lib/auto-complete'

import 'antd/lib/auto-complete/style'

export * from 'antd/lib/auto-complete'

export default AutoComplete
